import React, { useEffect, useState } from 'react';
import { orderBy } from '@progress/kendo-data-query';
import ExpandableGridV2 from '@components/core/expandable/grid-v2';
import { GridColumnDateFilter, GridColumnMenuActiveFilter } from '@components/core/grid-filters';
import { restructuredUpdatedCreatedBy } from '@utils-clean/update-users-array';
import { useGridCells, useTranslation } from '@hooks/index';

const FunctionalDataReviewGrid = ({ className, items, rowActions }: any) => {
    const { t } = useTranslation();
    const { MaxLengthCell, DateCell, YesNoCell, ActiveInactiveCell } = useGridCells();
    const [data, setData] = useState(null);

    useEffect(() => {
        if (items) {
            const newData = restructuredUpdatedCreatedBy(items?.libraryFunctionalDataReviews);
            const arrayToSort =
                orderBy(newData, [
                    { field: 'active', dir: 'desc' },
                    { field: 'updated', dir: 'desc' },
                ]) ?? [];
            setData(arrayToSort);
        }
    }, [items]);

    return (
        <ExpandableGridV2
            title={t('ra:functionalDataReviews')}
            className={className}
            customKey="admin-functionalDataReview-grid"
            id="admin-functionalDataReview-grid"
            items={data ?? []}
            initialSort={[{ field: 'description', dir: 'asc' }]}
            groupable
            hideCheckbox
            showPager
            scrollable="scrollable"
            reorderable
            resizable
            pageable={false}
            rowActions={rowActions}
            columns={[
                {
                    label: t('active'),
                    id: 'functionalDataReview-active',
                    field: 'active',
                    minWidth: 140,
                    cells: { data: YesNoCell },
                    filterUi: GridColumnMenuActiveFilter,
                },
                {
                    label: t('ra:description'),
                    id: 'functionalDataReview-description',
                    field: 'description',
                    minWidth: 250,
                    cells: { data: MaxLengthCell(150) },
                },
                {
                    label: t('ra:responsibleFunction'),
                    id: 'functionalDataReview-responsible-func',
                    field: 'responsibleFunction.name',
                    minWidth: 260,
                    cells: {
                        data: ActiveInactiveCell(
                            (dataItem: any) => dataItem.responsibleFunction?.active === false,
                            (dataItem: any) => dataItem.responsibleFunction?.name,
                        ),
                    },
                },
                {
                    label: t('ra:createdBy'),
                    id: 'functionalDataReview-createdby',
                    field: '_createdByString',
                    minWidth: 180,
                    showByDefault: false,
                },
                {
                    label: t('ra:createdDate'),
                    id: 'functionalDataReview-created',
                    minWidth: 200,
                    field: 'created',
                    cells: { data: DateCell },
                    filter: 'date',
                    filterUi: GridColumnDateFilter,
                    showByDefault: false,
                },
                {
                    label: t('ra:updatedBy'),
                    id: 'functionalDataReview-updatedby',
                    field: '_updatedByString',
                    minWidth: 180,
                    showByDefault: false,
                },
                {
                    label: t('ra:updatedDate'),
                    field: 'updated',
                    id: 'functionalDataReview-updated',
                    minWidth: 200,
                    filter: 'date',
                    cells: { data: DateCell },
                    filterUi: GridColumnDateFilter,
                    showByDefault: false,
                },
            ]}
        />
    );
};

export default FunctionalDataReviewGrid;
